import { Outlet, useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useTheme } from '@/components/ThemeProvider';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '@/store';

interface ITab {
  label: string;
  link: string;
  activeIcon: string;
  defaultIcon: string;
  customMatch: boolean;
  customRoute: boolean;
}

export default function TabLayout() {
  const { theme } = useTheme();
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const {
    chainTokenAddressMap,
    tokenPath,
    chainInfo: { path },
  } = useAppStore();
  const navigate = useNavigate();

  const tokenAddress = chainTokenAddressMap[path];

  const tabs: ITab[] = [
    {
      label: 'Tabbar.token',
      defaultIcon: theme == 'light' ? '/icon/trending.default.png' : '/icon/trending.default.dark.png',
      activeIcon: '/icon/trending.light.png',
      link: `/${path}/token`,
      customMatch: false,
      customRoute: true,
    },
    {
      label: 'Tabbar.trade',
      defaultIcon: theme == 'light' ? '/icon/trade.default.light.png' : '/icon/trade.default.dark.png',
      activeIcon: '/icon/trade.active.light.png',
      link: `/${path}/trade/${tokenAddress}`,
      customMatch: true,
      customRoute: false,
    },
    {
      label: 'Tabbar.account',
      defaultIcon: theme == 'light' ? '/icon/account.default.png' : '/icon/account.default.dark.png',
      activeIcon: '/icon/account.light.png',
      link: `/${path}/account`,
      customMatch: false,
      customRoute: false,
    },
  ];
  const onJump = (tab: ITab) => {
    if (tab.customRoute) {
      if (tokenPath) {
        navigate(tokenPath);
      } else {
        navigate(`/${path}/token/trending`);
      }
    } else {
      navigate(tab.link);
    }
  };

  return (
    <main className="">
      <Outlet />
      <div className="flex fixed left-0 z-10 right-0 bottom-0 h-[64px] justify-around bg-primaryBgColor shadow-[0px_-2px_4px_-2px_rgba(38,38,38,0.5)] rounded-tl-[8px] rounded-tr-[8px] light:border-[#E4E4E7] dark:border-[#27272A] border-t-[1px] border-solid">
        {tabs.map((tab, index) => {
          let state = false;
          if (tab.customMatch) {
            state = pathname.includes(`/${path}/trade`);
          } else {
            state = pathname.startsWith(tab.link);
          }
          return (
            <div
              key={index}
              className={cn(
                'flex flex-1 justify-center items-center gap-x-[3px] w-full flex-col gap-y-[6px] ${state && activeClass}',
                tab.customMatch && 'relative top-[-12px]',
              )}
              onClick={() => onJump(tab)}
            >
              <img
                className={cn('size-[24px]', tab.customMatch && 'size-[44px] transition', tab.customMatch && state && 'rotate-180')}
                src={state ? tab.activeIcon : tab.defaultIcon}
              />
              <span className={cn('text-[12px] text-secondaryTextColor', state && 'text-primaryTextColor')}>{t(tab.label)}</span>
            </div>
          );
        })}
      </div>
    </main>
  );
}
